export const ICON_SIZE = 40;
